var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9355 53.0645C14.4404 53.0645 12.4194 51.0435 12.4194 48.5484V32.7419H5.64516C3.15004 32.7419 1.12903 34.763 1.12903 37.2581V64.3549C1.12903 66.85 3.15004 68.871 5.64516 68.871H39.5161C42.0112 68.871 44.0323 66.85 44.0323 64.3549V53.0645H16.9355Z",
    fill: "#FCD770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3226 37.2581V48.5484C55.3226 51.0435 53.3016 53.0645 50.8064 53.0645H16.9355C14.4404 53.0645 12.4193 51.0435 12.4193 48.5484V21.4516C12.4193 18.9565 14.4404 16.9355 16.9355 16.9355H50.8064C53.3016 16.9355 55.3226 18.9565 55.3226 21.4516V37.2581Z",
    fill: "#E6E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0323 35L25.9677 44.0323V25.9678L44.0323 35Z",
    fill: "#FF826E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9677 16.9355V5.64516C25.9677 3.15004 27.9888 1.12903 30.4839 1.12903H64.3548C66.85 1.12903 68.871 3.15004 68.871 5.64516V32.7419C68.871 35.2371 66.85 37.2581 64.3548 37.2581H55.3226V21.4516C55.3226 18.9565 53.3016 16.9355 50.8065 16.9355H25.9677Z",
    fill: "#48CFAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8064 62.0967V64.3548H11.2903V59.8387H15.8064V62.0967Z",
    fill: "#E6E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8065 22.5806V31.6129H18.0645V22.5806H22.5807V20.3226H18.0645C16.8192 20.3226 15.8065 21.3353 15.8065 22.5806Z",
    fill: "#1E1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8065 33.871H18.0645V36.129H15.8065V33.871Z",
    fill: "#1E1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8065 38.3871H18.0645V40.6451H15.8065V38.3871Z",
    fill: "#1E1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6774 36.129H51.9355V38.3871H49.6774V36.129Z",
    fill: "#1E1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6774 40.6451H51.9355V42.9032H49.6774V40.6451Z",
    fill: "#1E1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6774 45.1613H51.9355V47.4194H49.6774V45.1613Z",
    fill: "#1E1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51611 42.9032H6.77418V45.1613H4.51611V42.9032Z",
    fill: "#1E1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51611 47.4194H6.77418V49.6774H4.51611V47.4194Z",
    fill: "#1E1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51611 38.3871H6.77418V40.6451H4.51611V38.3871Z",
    fill: "#1E1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3548 0H30.4839C27.3713 0 24.8387 2.5326 24.8387 5.64516V15.8065H16.9355C13.8229 15.8065 11.2903 18.3391 11.2903 21.4516V31.6129H5.64516C2.5326 31.6129 0 34.1455 0 37.2581V64.3548C0 67.4674 2.5326 70 5.64516 70H39.5161C42.6287 70 45.1613 67.4674 45.1613 64.3548V54.1936H50.8065C53.919 54.1936 56.4516 51.6609 56.4516 48.5484V38.3871H64.3548C67.4674 38.3871 70 35.8545 70 32.7419V5.64516C70 2.5326 67.4674 0 64.3548 0ZM42.9032 64.3548C42.9032 66.222 41.3833 67.7419 39.5161 67.7419H5.64516C3.77796 67.7419 2.25806 66.222 2.25806 64.3548V37.2581C2.25806 35.3909 3.77796 33.871 5.64516 33.871H11.2903V48.5484C11.2903 51.6609 13.8229 54.1936 16.9355 54.1936H42.9032V64.3548ZM54.1936 48.5484C54.1936 50.4156 52.6737 51.9355 50.8065 51.9355H16.9355C15.0683 51.9355 13.5484 50.4156 13.5484 48.5484V21.4516C13.5484 19.5844 15.0683 18.0645 16.9355 18.0645H50.8065C52.6737 18.0645 54.1936 19.5844 54.1936 21.4516V48.5484ZM63.2258 9.03226H47.4194V6.77419H63.2258V9.03226ZM67.7419 32.7419C67.7419 34.6091 66.222 36.129 64.3548 36.129H56.4516V21.4516C56.4516 18.3391 53.919 15.8065 50.8065 15.8065H47.4194V11.2903H63.2258V22.7885C62.8713 22.6617 62.4943 22.5806 62.0968 22.5806C60.2296 22.5806 58.7097 24.1005 58.7097 25.9677C58.7097 27.8349 60.2296 29.3548 62.0968 29.3548C63.964 29.3548 65.4839 27.8349 65.4839 25.9677V4.51613H45.1613V15.8065H27.0968V5.64516C27.0968 3.77796 28.6167 2.25806 30.4839 2.25806H64.3548C66.222 2.25806 67.7419 3.77796 67.7419 5.64516V32.7419ZM63.2258 25.9677C63.2258 26.5907 62.7197 27.0968 62.0968 27.0968C61.4738 27.0968 60.9677 26.5907 60.9677 25.9677C60.9677 25.3448 61.4738 24.8387 62.0968 24.8387C62.7197 24.8387 63.2258 25.3448 63.2258 25.9677Z",
    fill: "#1E1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8387 45.8592L46.5566 35L24.8387 24.1408V45.8592ZM27.0968 27.7947L41.5079 35L27.0968 42.2053V27.7947Z",
    fill: "#1E1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9355 58.7097H10.1613V60.9677H4.51611V63.2258H10.1613V65.4838H16.9355V63.2258H40.6451V60.9677H16.9355V58.7097ZM14.6774 63.2258H12.4193V60.9677H14.6774V63.2258Z",
    fill: "#1E1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3548 4.51611H42.9032V6.77418H29.3548V4.51611Z",
    fill: "#1E1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3548 9.03229H42.9032V11.2904H29.3548V9.03229Z",
    fill: "#1E1713"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoryIcon);
export default __webpack_public_path__ + "static/media/memoryIcon.3ab430274f5ed6a7774dc9fc93277610.svg";
export { ForwardRef as ReactComponent };